import bg1 from '../assets/images/resources/backgrounds/MOTIVO_01.jpg';
import bg2 from '../assets/images/resources/backgrounds/MOTIVO_03.jpg';
import bg3 from '../assets/images/resources/backgrounds/MOTIVO_05.jpg';
import bg4 from '../assets/images/resources/backgrounds/MOTIVO_06.jpg';
import bg5 from '../assets/images/resources/backgrounds/MOTIVO_07.jpg';
import bg6 from '../assets/images/resources/backgrounds/MOTIVO_10.jpg';
import bg7 from '../assets/images/resources/backgrounds/MOTIVO_13.jpg';
import bg8 from '../assets/images/resources/backgrounds/MOTIVO_14.jpg';
import bg9 from '../assets/images/resources/backgrounds/MOTIVO_15.jpg';
import bg10 from '../assets/images/resources/backgrounds/MOTIVO_16.jpg';

import texture1 from '../assets/images/resources/textures/TEXTURA_01.png';
import texture2 from '../assets/images/resources/textures/TEXTURA_02.png';
import texture3 from '../assets/images/resources/textures/TEXTURA_03.png';
import texture4 from '../assets/images/resources/textures/TEXTURA_04.png';
import texture5 from '../assets/images/resources/textures/TEXTURA_05.png';
import texture6 from '../assets/images/resources/textures/TEXTURA_06.png';
import texture7 from '../assets/images/resources/textures/TEXTURA_07.png';
import texture8 from '../assets/images/resources/textures/TEXTURA_08.png';

import ill1 from '../assets/images/resources/ex-libris/illustrations/ILUSTRACIONES_01.png';
import ill2 from '../assets/images/resources/ex-libris/illustrations/ILUSTRACIONES_03.png';
import ill3 from '../assets/images/resources/ex-libris/illustrations/ILUSTRACIONES_04.png';
import ill4 from '../assets/images/resources/ex-libris/illustrations/ILUSTRACIONES_05.png';
import ill5 from '../assets/images/resources/ex-libris/illustrations/ILUSTRACIONES_06.png';
import ill6 from '../assets/images/resources/ex-libris/illustrations/ILUSTRACIONES_07.png';
import ill7 from '../assets/images/resources/ex-libris/illustrations/ILUSTRACIONES_08.png';
import ill8 from '../assets/images/resources/ex-libris/illustrations/ILUSTRACIONES_09.png';
import ill9 from '../assets/images/resources/ex-libris/illustrations/ILUSTRACIONES_11.png';
import ill10 from '../assets/images/resources/ex-libris/illustrations/ILUSTRACIONES_12.png';

import detail1 from '../assets/images/resources/ex-libris/details/ELEMENTOS_04.png';
import detail2 from '../assets/images/resources/ex-libris/details/ELEMENTOS_05.png';
import detail3 from '../assets/images/resources/ex-libris/details/ELEMENTOS_07.png';
import detail4 from '../assets/images/resources/ex-libris/details/ELEMENTOS_09.png';
import detail5 from '../assets/images/resources/ex-libris/details/ELEMENTOS_11.png';
import detail6 from '../assets/images/resources/ex-libris/details/ELEMENTOS_12.png';
import detail7 from '../assets/images/resources/ex-libris/details/ELEMENTOS_13.png';
import detail8 from '../assets/images/resources/ex-libris/details/ELEMENTOS_14.png';
import detail9 from '../assets/images/resources/ex-libris/details/ELEMENTOS_15.png';
import detail10 from '../assets/images/resources/ex-libris/details/ELEMENTOS_19.png';

import title1 from '../assets/images/resources/ex-libris/titles/TITULOS_01.png';
import title2 from '../assets/images/resources/ex-libris/titles/TITULOS_02.png';
import title3 from '../assets/images/resources/ex-libris/titles/TITULOS_03.png';
import title4 from '../assets/images/resources/ex-libris/titles/TITULOS_04.png';
import title5 from '../assets/images/resources/ex-libris/titles/TITULOS_05.png';
import title6 from '../assets/images/resources/ex-libris/titles/TITULOS_06.png';
import title7 from '../assets/images/resources/ex-libris/titles/TITULOS_07.png';
import title8 from '../assets/images/resources/ex-libris/titles/TITULOS_08.png';

import iconFondos from '../assets/images/icons/icon_fondos.svg';
import iconFondosSelected from '../assets/images/icons/icon_fondos_selected.svg';
import iconTexturas from '../assets/images/icons/icon_texturas.svg';
import iconTexturasSelected from '../assets/images/icons/icon_texturas_selected.svg';
import iconIlustraciones from '../assets/images/icons/icon_ilustraciones.svg';
import iconIlustracionesSelected from '../assets/images/icons/icon_ilustraciones_selected.svg';
import iconDetalles from '../assets/images/icons/icon_detalles.svg';
import iconDetallesSelected from '../assets/images/icons/icon_detalles_selected.svg';
import iconTitulos from '../assets/images/icons/icon_titulos.svg';
import iconTitulosSelected from '../assets/images/icons/icon_titulos_selected.svg';
import { CSSProperties } from 'react';

interface Resources {
  style: CSSProperties;
  images: string[];
}

interface GalleryCategories {
  [key: string]: Resources;
}

export const EX_LIBRIS_SETTINGS: SelectedCategorySettings<GalleryCategories> = {
  title: '04 • Ex Libris',
  gallery: {
    fondos: {
      style: {
        objectFit: 'cover',
        objectPosition: 'top',
      },
      images: [bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9, bg10],
    },
    texturas: {
      style: {
        objectFit: 'contain',
        backgroundColor: '#8d8d8d',
      },
      images: [texture1, texture2, texture3, texture4, texture5, texture6, texture7, texture8],
    },
    ilustraciones: {
      style: {
        objectFit: 'contain',
        backgroundColor: '#c9c9c9',
      },
      images: [ill1, ill2, ill3, ill4, ill5, ill6, ill7, ill8, ill9, ill10],
    },
    detalles: {
      style: {
        objectFit: 'contain',
        backgroundColor: '#c9c9c9',
      },
      images: [
        detail1,
        detail2,
        detail3,
        detail4,
        detail5,
        detail6,
        detail7,
        detail8,
        detail9,
        detail10,
      ],
    },
    titulos: {
      style: {
        objectFit: 'contain',
        backgroundColor: '#c9c9c9',
      },
      images: [title1, title2, title3, title4, title5, title6, title7, title8],
    },
  },
  toolsSelection: [
    {
      key: 'fondos',
      name: 'Fondos',
      icon: iconFondos,
      selectedIcon: iconFondosSelected,
    },
    {
      key: 'texturas',
      name: 'Texturas',
      icon: iconTexturas,
      selectedIcon: iconTexturasSelected,
    },
    {
      key: 'ilustraciones',
      name: 'Ilustraciones',
      icon: iconIlustraciones,
      selectedIcon: iconIlustracionesSelected,
    },
    {
      key: 'detalles',
      name: 'Detalles',
      icon: iconDetalles,
      selectedIcon: iconDetallesSelected,
    },
    {
      key: 'titulos',
      name: 'Títulos',
      icon: iconTitulos,
      selectedIcon: iconTitulosSelected,
    },
  ],
};
